import i18n from 'config/i18n';
import * as Yup from 'yup';

export const defaultSectionSchema = Yup.object().shape({
  dutyTypeFlags: Yup.array().default([]),
  valid: Yup.object({
    from: Yup.date()
      .required(
        i18n.t('validationFieldRequired', { name: i18n.t('validFrom') })
      )
      .nullable()
      .default(null),
    to: Yup.date()
      .required(i18n.t('validationFieldRequired', { name: i18n.t('validTo') }))
      .nullable()
      .default(null)
      .min(Yup.ref<Date>('from'), i18n.t('invalidInterval'))
  })
});
